<template>
  <div
    class="transfer-wapper"
    ref="father">
    <div class="head" v-if="subtitle">
      <div class="head-down">
        <p><span>{{ subtitle }}</span></p>
      </div>
    </div>
    <el-transfer
      v-model="value"
      :data="data"
      :titles="['隐藏字段', '显示字段']"/>
    <div class="transfer-footer">
      <el-button
        type="primary"
        size="medium"
        :loading="saving"
        @click="searchSave">保存</el-button>
      <el-button
        type="warning"
        size="medium"
        class="jm-button-normal"
        @click="searchReset">重置</el-button>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    visible: {
      type: Boolean
    },
    refresh: {
      type: [Boolean, Number],
      default: false,
    },
  },
  data() {
    return {
      value: [], // 新值
      data: [],
      oldValue: [], // 初始化绑定值
      filelistId: null,
      originFields: {},
      saving: false,
    };
  },
  mounted() {
    /*
    * 初始化数
    * */
    this.getDatasource();
  },
  methods: {
    /*
    * 保存数据
    * */
    searchSave() {
      this.saving = true;
      let saveVal = [...this.value];
      saveVal.forEach((f, i) => {
        if (f in this.originFields && this.originFields[f] !== true) {
          saveVal[i] = `${f}:${this.originFields[f]}`;
        }
        if (!f) { // bugfix: 多出来一个空值，自定义搜索项
          saveVal.splice(i, 1);
        }
      });
      this.$http._post({
        url: '/index/field_list/save',
        data: {
          fields: saveVal,
          name: this.name,
          type: this.type === 'list' ? 1 : 2,
          id: this.filelistId,
        },
      }).then(({ data }) => {
        this.saving = false;
        if ((data.id)) {
          this.filelistId = data.id;
          this.$message.success('保存成功');
          this.oldValue = this.value;
          this.$emit('close-dialog', true, this.type);
          if (this.type === 'list') {
            this.$store.commit('updateRefresh', true);
          } else {
            this.$store.commit('updateFilterFields', this.oldValue);
          }
          return true;
        }
        this.$message.error('保存失败');
      });
    },
    /*
    * 重置
    * */
    searchReset() {
      this.value = [];
      Object.values(this.data).forEach((item) => {
        if (item.disabled) {
          this.value.push(item.key);
        }
      });
    },
    /*
    * 请求数据接口 挂载穿梭框数据
    * */
    getDatasource() {
      this.$http._get({
        url: `/index/field_list/read/type/${this.type}/name/${this.name}`,
      }).then(({ data }) => {
        this.originFields = data.show.fields;
        const listData = [];
        Object.entries(data.list).forEach(([key, label]) => {
          listData.push({
            key,
            label,
            disabled: data.ensured.indexOf(key) > -1
          });
        });
        this.data = listData;
        if (data.show) {
          this.filelistId = data.show.id;
          this.value = Object.keys(data.show.fields);
          this.oldValue = this.value;
        }
      });
    }
  },
  watch: {
    visible(val) {
      if (val === false) {
        this.value = this.oldValue;
      }
    }
  }
};
</script>
<style>
.head-down {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 15px 4px;
}

.head-down p {
  font-weight: 800;
  box-sizing: border-box;
  border-bottom: solid 4px #f0f0f0;
  margin-top: 4px;
  padding-bottom: 7px;
}

.head-down span {
  border-bottom: 3px solid #010D2D;
  font-weight: normal;
  padding-bottom: 7px;
}

.transfer-footer {
  width: 100%;
  border-top: 4px solid #f0f0f0;
  text-align: center;
  width: 91%;
  margin: auto;
  padding: 15px 0 30px;
}

.transfer-footer .el-button {
  width: 95px !important;
  outline: none;
  background: #3368fa !important;
  color: #fff !important;
}
.transfer-footer .el-button:nth-of-type(2){
  background: rgb(235,240,255) !important;
  border-color: rgb(235,240,255) !important;
  color: #3368fa !important;
}
.save {
  background: #3368fa;
  margin-right: 15px;
}

.reset {
  background: #67d100;
  margin-left: 15px;
}

.transfer-wapper {
  /*height: 424px;*/
  margin: 0 auto;
  box-shadow: none;
}

.transfer-wapper .el-transfer {
  display: flex;
  width: 100%;
  height: 400px;
  box-sizing: border-box;
  padding:20px 10px;
  justify-content: center;
  align-items: center;
}

.transfer-wapper .el-transfer-panel {
  width: 40% !important;
  height: 100%;
  border-radius: 14px;
}
.el-transfer-panel .el-transfer-panel__header,.el-transfer-panel .el-transfer-panel__header .el-checkbox{
  height: 62px;
  line-height: 62px;
}
.el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label{
  font-size: 14px;
}
.transfer-wapper .el-transfer-panel__body{
  padding-bottom: 0;
  height:296px;
}
.transfer-wapper .el-transfer-panel__list{
  height:296px;
}
.el-transfer-panel__item.el-checkbox .el-checkbox__label:hover{
  color: #3368fa;
}
.el-transfer__button{
  background: url(../../assets/ui2020/icon-arrow4.png) no-repeat 17px center !important;
  width: 40px !important;
  height: 40px !important;
  border-radius: 100% !important;
  border:1px solid #3368fa !important;
}
.el-transfer__button i{
  display: none !important;
}
.el-transfer__button:first-of-type{
  background: url(../../assets/ui2020/icon-arrow3.png) no-repeat 14px center !important;
}
.el-transfer__button.is-disabled{
  opacity: .4 !important;
}
</style>
